/**
 * If user tries to place a limit order without a limit price
 * {
	"messageType": "alertNotification",
	"notificationId": 1645221728514,
	"notificationDetails": {"errorType":"ORDER_VALIDATION","notificationType":"ERROR","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "NO_LIMIT_PRICE",
	"statusDetails": {"symbol":"XYZ"},
	"date": "2022-02-18T17:02:09.388-0500",
	"timestamp": "1645221729388"
}

 * @param {*} statusDetails 
 * @returns object with field:
 * 1) symbol. the symbol of the limit order you tried to place.
 */
export function noLimitPriceParser(statusDetails) {
  const parsedObj = {
    symbol: null,
  };
  if (statusDetails) {
    parsedObj.symbol = statusDetails.symbol ?? null;
  }

  return parsedObj;
}
